import styled from 'styled-components';

export const HeaderLink = styled.a`
  margin: 20px;
`;
